/**
 * blog-posts-cc.js
 * Enhances the mobile swipe carousel with mouse-drag support
 * (for desktop users who resize to narrow widths or use touch-screens).
 *
 * No dependencies. Lightweight — ~40 lines of logic.
 */

(function () {
  'use strict';

  function initDragScroll(grid) {
    var isDown  = false;
    var startX  = 0;
    var scrollL = 0;

    grid.addEventListener('mousedown', function (e) {
      isDown  = true;
      startX  = e.pageX - grid.offsetLeft;
      scrollL = grid.scrollLeft;
      grid.style.cursor = 'grabbing';
    });

    grid.addEventListener('mouseleave', function () {
      isDown = false;
      grid.style.cursor = '';
    });

    grid.addEventListener('mouseup', function () {
      isDown = false;
      grid.style.cursor = '';
    });

    grid.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x    = e.pageX - grid.offsetLeft;
      var walk = (x - startX) * 1.5;
      grid.scrollLeft = scrollL - walk;
    });
  }

  function boot() {
    var grids = document.querySelectorAll('.blog-posts-cc__grid');
    grids.forEach(initDragScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify Theme Editor reload support */
  document.addEventListener('shopify:section:load', function (e) {
    var grid = e.target.querySelector('.blog-posts-cc__grid');
    if (grid) initDragScroll(grid);
  });

}());